<script>
	import { enhance } from '$app/forms';
	import { page } from '$app/stores';
	import { env as envPublic } from '$env/dynamic/public';
	import { Content } from '@builder.io/sdk-svelte';
	import { Button, Logo } from '@resider/design-system';
	import customComponents from '@resider/design-system/builder.io';
	import { t } from '@resider/i18n';
</script>

<div class="auth-form">
	<main>
		<header>
			<Logo href="/{$page.params.lang}" --height="2.5rem" />

			{#if $page.params.sign_up}
				<h1>{$t('global.Join for free')}</h1>
			{:else if $page.params.sign_in}
				{#if $page.url.searchParams.get('next')?.match(/konto|account/)}
					<h1>{$t('global.Sign in to access your account')}</h1>
				{:else}
					<h1>{$t('global.Sign in')}</h1>
				{/if}
			{:else if $page.params.reset_password}
				<h1>{$t('global.Reset your password')}</h1>
			{/if}
		</header>

		{#if !$page.params.confirm_account && !$page.params.reset_password && !$page.form?.message.includes('Invalid login credentials')}
			{#if $page?.form?.message.includes('not confirmed')}
				<mark>
					{$t('global.Confirm your account by enterink a link we sent you to your email.')}
				</mark>
			{:else}
				<form
					action="?/{$page.params.sign_up
						? 'google_signup'
						: 'google_signin'}&next={$page.url.searchParams.get('next') ||
						encodeURIComponent(`/${$page.params.lang}/${$t('slugs.account')}`)}"
					method="POST"
					use:enhance
				>
					<Button kind="secondary" type="submit">
						<Logo file="google-g-logo" --height="1.5rem" />

						{$t('global.Sign in with {{provider}}', {
							// @ts-ignore
							provider: 'Google'
						})}
					</Button>
				</form>
			{/if}

			<span>{$t('global.or')}</span>
		{/if}

		<slot />

		{#key $page.url}
			<section class="switch-auth-mode">
				{#if $page.params.signup}
					<span>{$t('global.Already a user?')}</span>

					<Button
						href="/{$page.params.lang}/{$t('slugs.sign-in')}{$page.url.search}"
						kind="tertiary"
					>
						{$t('global.Sign in')}
					</Button>
				{:else if $page.params.signin}
					<span>{$t(`global.Don't have an account?`)}</span>

					<Button
						href="/{$page.params.lang}/{$t('slugs.sign-up')}{$page.url.search}"
						kind="tertiary"
					>
						{$t('global.Join for free')}
					</Button>
				{:else if $page.params.reset_password}
					<Button
						href="/{$page.params.lang}/{$t('slugs.sign-in')}{$page.url.search}"
						kind="tertiary"
						on:click={(e) => e.preventDefault}
					>
						{$t('global.Go back to sign in')}
					</Button>
				{/if}
			</section>
		{/key}
	</main>

	{#key $page.data.content}
		<aside>
			<Content
				model="page"
				content={$page.data.content}
				apiKey={envPublic.PUBLIC_BUILDER_PUBLIC_API_KEY}
				{customComponents}
			/>
		</aside>
	{/key}
</div>

<style lang="postcss">
	header {
		display: grid;
		gap: 4rem;
		place-items: center;
		margin-bottom: 1rem;
		@media (width > 767px) {
			margin-bottom: 2rem;
		}
	}

	.auth-form {
		display: grid;
		@media (width > 1024px) {
			grid-template-columns: auto max(20rem, 50vw);
		}
		min-height: var(--innerHeight, 100vh);
	}

	main {
		display: grid;
		gap: 2rem;
		place-content: center;
		text-align: center;
		padding: 2rem;

		:global(h1) {
			font: var(--f-heading-xxl-bold);
			@media (width <= 480px) {
				font: var(--f-heading-xl-bold);
			}
		}
	}

	aside {
		background: hsla(var(--hsl-primary), 0.1);
		display: grid;
		place-items: center;
		padding: 2rem;
	}

	.switch-auth-mode {
		display: grid;
		justify-items: center;
		gap: 1rem;
		margin-top: 1rem;
		@media (width > 767px) {
			margin-top: 2rem;
		}
	}

	span {
		font: var(--f-ui-md-medium);
	}

	form {
		display: grid;
	}

	:global(mark) {
		background: hsla(var(--hsl-warning), 0.1);
		color: hsla(var(--hsl-warning));
		font: var(--f-paragraph-md-semibold);
		border: 2px solid hsla(var(--hsl-warning));
		border-radius: 1rem;
		padding: 1.5rem;
	}
	:global(mark.success) {
		background: hsla(var(--hsl-success), 0.1);
		color: hsla(var(--hsl-success));
		border: 2px solid hsla(var(--hsl-success));
	}
</style>
